var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.is_external_link)?_c('a',{class:_vm.classnames,attrs:{"href":_vm.to}},[_vm._t("default")],2):(_vm.to)?_c('router-link',{class:_vm.classnames,attrs:{"to":_vm.to}},[_vm._t("default")],2):_c('span',{class:_vm.classnames},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }